/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Seg_Else_SInputs */

const en_funnel_ob_seg_else_s = /** @type {(inputs: Funnel_Ob_Seg_Else_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Books, scripts, anything at all`)
};

const es_funnel_ob_seg_else_s = /** @type {(inputs: Funnel_Ob_Seg_Else_SInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libros, guiones, lo que sea`)
};

/**
* | output |
* | --- |
* | "Books, scripts, anything at all" |
*
* @param {Funnel_Ob_Seg_Else_SInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_seg_else_s = /** @type {((inputs?: Funnel_Ob_Seg_Else_SInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Seg_Else_SInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_seg_else_s(inputs)
	return en_funnel_ob_seg_else_s(inputs)
});